module.exports = __webpack_public_path__ + "img/qr_code.372c1d50.png";